export default __webpack_public_path__ + "static/media/exc.c882a37a.png";